import styles from "./App.module.scss";
import logo from "../components/logo.svg";

function App() {
    let nothing = "There's nothing yet. Come back later :)";
    return (
        <>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logo} alt="logo" />
                </div>
                <div className={styles.body}>
                    <div className={styles.products}>
                        <h1>Products</h1>
                        <div className={styles.content}>
                            <ul>
                                <a href="https://github.com/dxtintx/modmail-bot">
                                    <li>ModMail Discord Bot</li>
                                </a>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.tools}>
                        <h1>Tools</h1>
                        <div className={styles.content}>{nothing}</div>
                    </div>
                    <div className={styles.history}>
                        <h1>History</h1>
                        <div className={styles.content}>{nothing}</div>
                        <div className={styles.footer}>
                            <button>Delete All</button>
                            <button>Disable</button>
                        </div>
                    </div>
                    <div
                        className={`${styles.separator1} ${styles.separator}`}
                    ></div>
                    <div
                        className={`${styles.separator2} ${styles.separator}`}
                    ></div>
                </div>
            </div>
        </>
    );
}

export default App;
